module.exports = __webpack_public_path__ + "media/images/techno_logo_black_main-1a838476.png";